<template>
    <!-- 兑换活动管理-兑换订单 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'exchangeGiftOrder')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="订单号">
                        <a-input placeholder="请输入" v-decorator="['orderId']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="礼券ID">
                        <a-select allowClear placeholder="请选择" v-decorator="['couponId']" @select="search">
                            <a-select-option :value="item.id" v-for="item in couponList" :key="item.id">礼券ID：{{item.id + '；礼券名称：' + item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="兑换简码">
                        <a-input placeholder="请输入" v-decorator="['shortCode']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <!-- <a-form-item label="序列号SN">
                        <a-input placeholder="请输入" v-decorator="['sn']"></a-input>
                    </a-form-item>
                    <a-form-item label="兑换方式">
                        <a-select allowClear placeholder="请选择" v-decorator="['type']">
                            <a-select-option value="0">通用码</a-select-option>
                            <a-select-option value="1">一物一码</a-select-option>
                        </a-select>
                    </a-form-item> -->
                    <a-form-item label="商品分类">
                        <a-select allowClear placeholder="请选择" v-decorator="['goodCategory']" @select="search">
                            <a-select-option value="1">线上票</a-select-option>
                            <a-select-option value="2">线下票</a-select-option>
                            <a-select-option value="3">优惠券</a-select-option>
                            <a-select-option value="4">储值</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="展示名称">
                        <a-input placeholder="请输入" v-decorator="['goodName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="内部标识">
                        <a-input placeholder="请输入" v-decorator="['goodInnerName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="兑换手机号">
                        <a-input placeholder="请输入" v-decorator="['createUser']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="兑换日期">
                        <a-range-picker
                            style="width:282px"
                            format="YYYY－MM－DD"
                            v-decorator="['validity']"
                            @change="search"
                        />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button :loading="loading" @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card title="兑换礼券订单" :bordered="false">
                <a-button slot="extra" v-if="getBtnByAuth('exchangeGiftExport')" type="primary" @click="exportCashOrderList">导出</a-button>
                <a-table
                :scroll="{y: 560}"
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                @change="changePage"
                :rowKey="(record, index) => index"
                >
                <span slot="orderId" slot-scope="orderId">{{orderId == -1 ? '-' : orderId}}</span>
                <span slot="goodCategory" slot-scope="goodCategory">{{['','线上票','线下票','优惠券','储值'][goodCategory]}}</span>
                <span slot="type" slot-scope="type">{{['通用码','一物一码'][type]}}</span>
                <span slot="isVerify" slot-scope="isVerify">{{isVerify ? '是' :'否'}}</span>
                <span slot="empty" slot-scope="empty">{{empty || '-'}}</span>
                <span slot="action" slot-scope="a,row">
                    <a v-if="getBtnByAuth('download')" class="text-primary" @click="downloadZip(row.id)">查看订单</a>
                </span>
                </a-table>
            </a-card>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    export default {
        name: "exchangeGiftOrder",
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: "订单号",
                    dataIndex: "orderId",
                    scopedSlots: { customRender: "orderId" }
                },
                {
                    title: '礼券ID',
                    dataIndex: 'couponId'
                },
                {
                    title: '兑换简码',
                    dataIndex: 'shortCode'
                },
                // {
                //     title: '序列号SN',
                //     dataIndex: 'sn'
                // },
                // {
                //     title: '兑换方式',
                //     dataIndex: 'type',
                //     scopedSlots: { customRender: "type" }
                // },
                {
                    title: '商品分类',
                    dataIndex: 'goodCategory',
                    scopedSlots: { customRender: "goodCategory" }
                },
                {
                    title: '展示名称',
                    dataIndex: 'goodName',
                },
                {
                    title: '内部标识',
                    dataIndex: 'goodInnerName',
                },
                {
                    title: '兑换手机号',
                    dataIndex: 'createUser',
                    scopedSlots: { customRender: "empty" }
                },
                {
                    title: '兑换时间',
                    dataIndex: 'createTime',
                },
                {
                    title: '是否核销',
                    dataIndex: 'isVerify',
                    scopedSlots: { customRender: "isVerify" }
                },
            ];
            return {
                cityList: [],
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                couponList: []
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            exportCashOrderList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const validity = values['validity'] ? values['validity'] : []
                    values.startCreateTime = validity.length > 0 ? validity[0].format('YYYY-MM-DD') : undefined
                    values.endCreateTime = validity.length > 0 ? validity[1].format('YYYY-MM-DD') : undefined
                    delete values.validity
                    this.$api.changeCode.exportCashOrderList({
                        body: Object.assign(values, {
                            shopId: this.shopId
                        })
                    },{
                        responseType: "blob"
                    }).then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });

                        this.downloadUrl = window.URL.createObjectURL(blob);

                        let name = this.$route.meta.name + '-' + this.$moment().format('YYYY/MM/DD') + '.xls'

                        a.setAttribute("href", this.downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                    })
                });
            },
            handleReset() {
                this.form.resetFields();
                this.pagination.current = 1;
                this.pagination.pageSize = 20;
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const validity = values['validity'] ? values['validity'] : []
                    values.startCreateTime = validity.length > 0 ? validity[0].format('YYYY-MM-DD') : ''
                    values.endCreateTime = validity.length > 0 ? validity[1].format('YYYY-MM-DD') : ''
                    delete values.validity

                    this.loading = true;
                    this.$api.changeCode
                    .cashOrderList({
                        query: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    })
                    .then(res => {
                        this.loading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    })
                    .catch(err => {
                        this.loading = false;
                    })
                });
            },
            getCouponList() {
                this.$api.changeCode.exchangeGiftList({
                    query: {
                        pageNum: 1,
                        pageSize: 999999
                    }
                })
                .then(res => {
                    this.couponList = res.list;
                });
            },
            downloadZip(id) {
                this.$message.success('下载中，请稍后...')
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.loading = true;
                    this.$api.changeCode
                    .downloadZip({
                        body: {
                            prizeRedemptionId: id
                        }
                    },
                    {
                        responseType: "blob"
                    })
                    .then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "application/zip"
                        });

                        this.downloadUrl = window.URL.createObjectURL(blob);

                        let name = this.$route.meta.name + '-' + this.$moment().format('YYYY/MM/DD') + '.zip'

                        a.setAttribute("href", this.downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                        this.loading = false

                    }).catch(err => {
                        this.loading = false

                    })
                });
            },

            // 跳转至详情
            toDetail(id) {
                this.$router.push({
                    name: "detailCode",
                    query: { id: id}
                });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList();
            this.getCouponList();
        },
        watch: {
            $route(val) {
                val.name == "changeCodeIndex" && this.getList();
            },
            'shopId'() {
                this.getList()
            }
        }
    };
</script>
<style lang="scss">
</style>